import { Injectable, inject } from '@angular/core';
import {
  WatchQueryFetchPolicy,
  ApolloLink,
  ObservableQuery,
} from '@apollo/client';
import {
  FindAllSitePermissionsRequest,
  FindAllSiteRolePermissionsRequest,
  SitePermission,
  SiteRolePermission,
} from '@ih/app/shared/apis/interfaces';
import { Store } from '@ngxs/store';
import { Apollo, gql } from 'apollo-angular';
import { map, Observable, take } from 'rxjs';

@Injectable()
export class SiteService {
  private readonly apollo = inject(Apollo);
  private readonly store = inject(Store);

  findUserPermissions(
    request: FindAllSiteRolePermissionsRequest,
  ): Observable<SiteRolePermission[]> {
    type ResultType = {
      findAllSiteRolePermissions: SiteRolePermission[] | null;
    };

    let fetchPolicy = 'cache-only';

    const networkStatus = this.store.selectSnapshot<boolean>(
      (state) => state.network.status,
    );

    if (networkStatus) {
      fetchPolicy = 'network-only';
    }

    const query = gql`
      query findAllSiteRolePermissions(
        $request: FindAllSiteRolePermissionsRequest!
      ) {
        findAllSiteRolePermissions(request: $request) {
          id
          sitePermissionId
        }
      }
    `;

    return this.apollo
      .watchQuery<ResultType>({
        query,
        variables: {
          request,
        },
        fetchPolicy: <WatchQueryFetchPolicy>fetchPolicy,
      })
      .valueChanges.pipe(
        take(1),
        map((result: ObservableQuery.Result<ResultType>) => {
          if (result.data && networkStatus) {
            this.apollo.client.cache.writeQuery({
              query,
              data: result.data,
            });
          }
          return (
            (result.data?.findAllSiteRolePermissions as
              | SiteRolePermission[]
              | undefined) ?? []
          );
        }),
      );
  }

  //ProjectMembers
  findAllSitePermissions(
    request: FindAllSitePermissionsRequest,
  ): Observable<SitePermission[]> {
    type ResultType = { findAllSitePermissions: SitePermission[] | null };
    let fetchPolicy = 'cache-only';

    const networkStatus = this.store.selectSnapshot<boolean>(
      (state) => state.network.status,
    );

    if (networkStatus) {
      fetchPolicy = 'network-only';
    }

    const query = gql`
      query findAllSitePermissions($request: FindAllSitePermissionsRequest!) {
        findAllSitePermissions(request: $request) {
          id
          identifier
        }
      }
    `;

    return this.apollo
      .watchQuery<ResultType>({
        query,
        variables: {
          request,
        },
        fetchPolicy: <WatchQueryFetchPolicy>fetchPolicy,
      })
      .valueChanges.pipe(
        take(1),
        map((result: ObservableQuery.Result<ResultType>) => {
          if (result.data && networkStatus) {
            this.apollo.client.cache.writeQuery({
              query,
              data: result.data,
            });
          }
          return (
            (result.data?.findAllSitePermissions as
              | SitePermission[]
              | undefined) ?? []
          );
        }),
      );
  }
}
